import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactUsRequest } from '@shared/models/request/contact-us-request.model';

export type ContactFormStatus = 'idle' | 'submitting' | 'success' | 'error';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent {
  @Input() status: ContactFormStatus = 'idle';
  @Output() submitForm = new EventEmitter<ContactUsRequest>();

  model: ContactUsRequest = new ContactUsRequest();
  attempted = false;

  get isSubmitting(): boolean {
    return this.status === 'submitting';
  }

  get hasError(): boolean {
    return this.status === 'error';
  }

  get hasSuccess(): boolean {
    return this.status === 'success';
  }

  onSubmit(): void {
    this.attempted = true;
    if (!this.isValid() || this.isSubmitting) {
      return;
    }
    this.submitForm.emit(new ContactUsRequest(this.model));
  }

  reset(): void {
    this.model = new ContactUsRequest();
    this.attempted = false;
  }

  isFieldInvalid(field: 'name' | 'email' | 'subject' | 'message'): boolean {
    if (!this.attempted) return false;
    const value = (this.model[field] || '').trim();
    if (!value) return true;
    if (field === 'email') return !this.isEmail(value);
    return false;
  }

  private isValid(): boolean {
    const m = this.model;
    return !!m.name?.trim()
      && !!m.email?.trim() && this.isEmail(m.email.trim())
      && !!m.subject?.trim()
      && !!m.message?.trim();
  }

  private isEmail(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }
}
